import { useContext, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import FormBody from "./FormBody";
import Form from "../../../../Helpers/Form/Form";
import FormHeader from "../../../../Helpers/Form/FormParts/FormHeader";
import { popupcontext } from "../../../../../context/Popupscontext";

export function ScheduleForm({ onSuccess, onEdit, start, end }) {
  const { form, isEditing } = useContext(popupcontext);

  //   const {
  //     refetch,
  //     data: vehicleDetails,
  //     isError,
  //   } = useGetSpecificVehicleQuery(currentVehicleId, { skip: !currentVehicleId });
  //   useEffect(() => {
  //     if (isEditing && currentVehicleId) {
  //       refetch();
  //     }
  //   }, [currentVehicleId, isEditing, ]);
  return (
    <>
      <Form show={form}>
        <Offcanvas.Header>
          <FormHeader
            title={isEditing ? "Edit event" : "Schedule a new maintenance"}
          />
        </Offcanvas.Header>
        <div className="H-line" />
        <Offcanvas.Body>
          <FormBody
            onSuccess={onSuccess}
            onEdit={onEdit}
            start={start}
            end={end}
          />
        </Offcanvas.Body>
      </Form>
    </>
  );
}
